import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import withStyles from "components/with-styles";
import styles from "./styles/item-icon.css.js";

const ItemIcon = ({ classes, disabled, children }) => (
  <ListItemIcon className={cn({ [classes.disabled]: disabled })}>{children}</ListItemIcon>
);

ItemIcon.propTypes = {
  /**
   * Indica si la entrada de menú está deshabilitada
   **/
  disabled: PropTypes.bool,
};

export default withStyles(styles)(ItemIcon);
